import { render, staticRenderFns } from "./controls.vue?vue&type=template&id=be6bc970&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./controls.vue?vue&type=script&lang=js&"
export * from "./controls.vue?vue&type=script&lang=js&"
import style0 from "./controls.vue?vue&type=style&index=0&id=be6bc970&prod&lang=css&"
import style1 from "./controls.vue?vue&type=style&index=1&id=be6bc970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6bc970",
  null
  
)

export default component.exports